import styled from 'styled-components'

export const NavWrapper = styled.nav`
  background-color: #ececec;
  width: 100vw;
  height: 7vh;
  display: flex;
  align-items: center;
  justify-content: left;
`

export const NavLink = styled.a`
  height: 100%;
`
